import React from 'react';

import serverApi from '../../utils/serverApi.js';

/**
 * A higher ticket component wrapper that updates the status of a ticket to accepted.
 *
 * @param {Object} WrappedComponent
 * @returns {Object}
 */
export default function ticketApproveByIdHOC(WrappedComponent) {
  /**
   * The TicketApproveById higher ticket component.
   */
  class TicketApproveById extends React.Component {
    /**
     * @constructor
     * @param {{}} props
     * @param {{}} componentContext
     */
    constructor(props, componentContext) {
      super(props, componentContext);

      this.state = {
        ticketId: null,
        isLoading: false,
        success: null,
        error: null,
      };
    }

    /**
     * Sets the ticket into the approved state.
     *
     * @param {number} ticketId
     */
    approveTicket = (ticketId) => {
      this.setState({
        ticketId,
        isLoading: true,
        success: null,
        error: null,
      }, () => {
        serverApi.ticketApproveById(ticketId).then((response) => {
          this.setState({
            isLoading: false,
            success: this.mapResponse(response),
            error: null,
          });
        }, (error) => {
          this.setState({
            isLoading: false,
            ticket: null,
            success: false,
            error,
          });
        });
      });
    };

    /**
     * Maps the Axios response to the ticket data.
     *
     * @param {{data: object}} response
     * @returns {object|null}
     */
    mapResponse = (response) => {
      if (!response || !response.data) {
        return null;
      }

      return response.data.success;
    };

    /**
     * Renders the WrappedComponent.
     *
     * @returns {Object}
     */
    render() {
      const newProps = {
        ticketApproveById: {
          approveTicket: this.approveTicket,
          isLoading: this.state.isLoading || false,
          success: this.state.success || null,
          error: this.state.error,
        }
      };

      return <WrappedComponent {...this.props} {...newProps} />
    }
  }

  TicketApproveById.propTypes = {};

  return TicketApproveById;
}



// WEBPACK FOOTER //
// ./src/components/hoc/ticketApproveByIdHoc.js